import { unparseCurrency } from 'utils/parsers';
import { VF } from './valorFuturo';
import { PGTO } from './valorParcela';

/**
 * calcula o valores e taxas de um financiamento
 * Giovani 09/01/2026
 * @param {object} proposta - dados ja cadsatrados da proposta bancaria
 * @param {object} taxas - dados das taxas aplicadas no financiamento
 * @returns {object} - retorn array com os valores calculados
 */
export function calculaFinanciamento(proposta, taxas) {
  //valores fixos
  const valorEntrada = proposta?.valor_entrada || 0;
  const valor_financiamento = unparseCurrency(
    proposta?.valor_financiamento || '0'
  );
  const valorBem = unparseCurrency(proposta.valor_venda); //valorEntrada + valor_financiamento;

  const prazoMeses = parseInt(proposta?.prazo_financiamento);
  //taxas

  const perTac = parseFloat(proposta.tacSN) || 0;
  const perSeguro =
    proposta?.seguroSN === 'Sim' ? parseFloat(taxas?.perc_seguro) : 0;

  const valorSeguroAss =
    proposta?.seguroAssisSN === 'Sim' ? taxas?.valor_seguro_assistencia : 0;
  const perTaxa = parseFloat(taxas?.perc_taxa) || 0;
  const perTabela = proposta?.tabSN || 0;

  const iof = taxas?.iof;
  const iof_mais = taxas?.iof_mais;
  const iof_pf = taxas?.perc_iof_pf;
  const iof_pj = taxas?.perc_iof_pj;

  const tempoIof = prazoMeses * 30;
  //faz o calculo do iof esta com padrao o iof PF, se for colocar o do iof PF, fazer a comparacao aqui.
  let taxaIof;
  if (tempoIof >= 360) {
    taxaIof = iof_pf * 360;
  } else {
    taxaIof = iof_pf * tempoIof;
  }

  const perIof = proposta?.iofSN === 'Sim' ? parseFloat(taxaIof.toFixed(2)) : 0;

  //carencia padrão
  const carenciaPadrao = proposta?.carencia; //taxas?.carencia_padrao;

  //calculos
  const valorTac =
    taxas.calculo_tac === 'fixo'
      ? taxas.valor_tac_fixo
      : (perTac / 100) * valor_financiamento;
  const valorTab = (perTabela / 100) * valor_financiamento;
  const valorSeguro = (perSeguro / 100) * valor_financiamento;
  let valorIof =
    (perIof / 100) *
    (valor_financiamento + valorTac + valorSeguro + valorTab + valorSeguroAss);
  valorIof = parseFloat(valorIof.toFixed(2));
  // let adicionalIof =
  //   (iof_mais / 100) *
  //   (valor_financiamento +
  //     valorTac +
  //     valorSeguro +
  //     valorTab +
  //     valorSeguroAss +
  //     valorIof);
  //arredonda o valor do IofAdicional para 2 casas decimais
  // adicionalIof = parseFloat(adicionalIof.toFixed(2));
  //Refaz o IOF adicioanndo ele mesmo no calculo, pois o iof tem incidência sobre ele mesmo e sobre o adicional do iof.
  valorIof =
    (perIof / 100) *
    (valor_financiamento +
      valorTac +
      valorSeguro +
      valorTab +
      valorSeguroAss +
      valorIof);
  // //Calcula o adicional de IOF
  // adicionalIof =
  //   (iof_mais / 100) *
  //   (valor_financiamento +
  //     valorTac +
  //     valorSeguro +
  //     valorTab +
  //     valorSeguroAss +
  //     valorIof +
  //     adicionalIof);
  //Valor final do IOF com o IOF adicional incluso
  valorIof = valorIof;

  const valorTaxa = (perTaxa / 100) * valor_financiamento;
  const valorPresente =
    valor_financiamento +
    valorTac +
    valorSeguro +
    valorTab +
    valorIof +
    valorSeguroAss;
  //calculo do valor da parcela
  const valorParcela =
    PGTO(perTaxa / 100, prazoMeses, -valorPresente, 0, 0) *
    Math.pow(1 + perTaxa / 100, (carenciaPadrao - 30) / 30);
  //salva os calculos na proposta em segundo objeto
  const resultado = {
    valorBem: parseFloat(valorBem.toFixed(2)),
    valorTac: parseFloat(valorTac.toFixed(2)),
    valorSeguro: parseFloat(valorSeguro.toFixed(2)),
    valorTaxa: parseFloat(valorTaxa.toFixed(2)),
    valorTab: parseFloat(valorTab.toFixed(2)),
    valorIof: parseFloat(valorIof.toFixed(2)),
    valorPresente: parseFloat(valorPresente.toFixed(2)),
    valorParcela: parseFloat(valorParcela.toFixed(2)),
    valorSeguroAssis: valorSeguroAss,
    perSeguro: perSeguro,
  };

  return resultado;
}

/**
 * Simulação simples da função TAXA do Excel
 * (sem precisão, sem validações, sem controle numérico)
 */
//feito por IA

export async function taxaCET(nper, pgto, vp, vf = 0, tipo = 0, chute = 0.1) {
  let r = chute;
  function f(x) {
    const a = Math.pow(1 + x, nper);
    // Equação: 0 = vp*(1+r)^n + pgto*(1+r*tipo)*((1+r)^n - 1)/r + vf
    return vp * a + (pgto * (1 + x * tipo) * (a - 1)) / x + vf;
  }
  for (let i = 0; i < 100; i++) {
    const fx = f(r);
    const h = 1e-7; // passo fixo pra derivada numérica
    const dfx = (f(r + h) - f(r - h)) / (2 * h);
    r = r - fx / dfx;
  }

  return (r * 100).toFixed(2);
}

/**
 * calcula o valores e taxas no cobranca
 * Carlos 24/02/2026
 * @param {object} proposta - dados ja cadsatrados
 * @param {object} taxas - dados das taxas aplicadas na cobranca
 * @returns {object} - retorn array com os valores calculados
 */
export function calculaCobranca(proposta, taxas) {
  //valores fixos

  const valor_total = proposta?.valor_total || 0;
  const valor_financiamento = proposta?.valor_renegociar || 0;
  const valor_entrada = proposta?.valor_entrada || 0;
  const valor_finanEntrada = valor_financiamento - valor_entrada;
  const valorBem = valor_entrada + valor_financiamento;
  const prazoMeses = parseInt(proposta?.prazo);
  //taxas
  //periodicidade padrão
  const periodicidadePadrao = proposta?.periodicidade;

  const perTac = taxas?.perc_tacSN || 0;
  const perSeguro =
    proposta?.seguroSN === 'Sim'
      ? parseFloat(taxas?.taxas?.[0].perc_seguro)
      : 0;
  const perTabela = taxas?.perc_tabSN || 0;

  //variaveis do iof
  const iofPF = taxas?.taxasiof.iof_pf;
  const iofPJ = taxas?.taxasiof.iof_pj;
  const iof = taxas?.taxasiof.iof;
  const iofmais = taxas?.taxasiof.iof_mais;
  const tempoIof = prazoMeses * periodicidadePadrao;
  //faz o calculo do iof esta com padrao o iof PF, se for colocar o do iof PF, fazer a comparacao aqui.
  let taxaIof;
  if (tempoIof >= 360) {
    taxaIof = iof;
  } else {
    taxaIof = iofPF * tempoIof + iofmais;
  }

  const perIof = proposta?.iofSN === 'Sim' ? parseFloat(taxaIof) : 0;
  const valorSeguroAss =
    proposta?.seguroAssisSN === 'Sim'
      ? taxas?.taxasbanco?.valor_seguro_assistencia
      : 0;

  const taxaRenegocio = proposta?.taxa;
  const perTaxa = (taxaRenegocio / 30) * periodicidadePadrao;

  //calculos
  const valorTac = (perTac / 100) * valor_finanEntrada;
  const valorTab = (perTabela / 100) * valor_finanEntrada;
  const valorSeguro = (perSeguro / 100) * valor_finanEntrada;
  const valorIof =
    (perIof / 100) * (valor_finanEntrada + valorTac + valorSeguro + valorTab);
  const valorTaxa = (perTaxa / 100) * valor_finanEntrada;
  //valor presente
  const valorPresente =
    valor_total + valorTac + valorSeguro + valorTab + valorIof + valorSeguroAss;

  //calculo do valor futuro
  const valorFuturo = VF(
    perTaxa / 100,
    (periodicidadePadrao - 30) / 30,
    0,
    -valorPresente,
    0
  );

  //calculo do valor da parcela
  // no ultimo campo da formula nesse caso de renegociacao é '1' , pois ja teve amortizacao.
  const valorParcela = PGTO(perTaxa / 100, prazoMeses, -valorPresente, 0, 1);
  //salva os calculos na proposta em segundo objeto
  //caso seja zerado o valor de renegociar vai estar trazendo os valores zerado.
  if (proposta.valor_renegociar <= 0) {
    const resultado = {
      valor_financiamento: 0,
      valorBem: 0,
      valorTac: 0,
      valorSeguro: 0,
      valorTaxa: 0,
      valorTab: 0,
      valorIof: 0,
      valorPresente: 0,
      valorFuturo: 0,
      valorParcela: 0,
      perSeguro: 0,
    };
    return resultado;
  }
  const resultado = {
    valor_financiamento: parseFloat(valor_financiamento.toFixed(2)),
    valorBem: parseFloat(valorBem.toFixed(2)),
    valorTac: parseFloat(valorTac.toFixed(2)),
    valorSeguro: parseFloat(valorSeguro.toFixed(2)),
    valorSeguroAssis: valorSeguroAss,
    valorTaxa: parseFloat(valorTaxa.toFixed(2)),
    valorTab: parseFloat(valorTab.toFixed(2)),
    valorIof: parseFloat(valorIof.toFixed(2)),
    valorPresente: parseFloat(valorPresente.toFixed(2)),
    valorFuturo: parseFloat(valorFuturo.toFixed(2)),
    valorParcela: parseFloat(valorParcela.toFixed(2)),
    perSeguro: perSeguro,
  };

  return resultado;
}

function calcularIOF(valorLiberado, tarifas = 0, diasOperacao) {
  if (valorLiberado <= 0) {
    throw new Error('Valor liberado deve ser maior que zero.');
  }

  // Base de calculo do IOF (vl principal + tarifas)
  const baseCalculo = valorLiberado + tarifas;

  // aliquotas oficiais
  const IOF_FIXO = 0.0038; // 0,38% adicional
  const IOF_DIARIO = 0.000082; // 0,0082% ao dia

  // Cálculo
  const iofFixo = baseCalculo * IOF_FIXO;
  const iofDiario = baseCalculo * IOF_DIARIO * Math.min(diasOperacao, 365); // max 365 dias

  const iofTotal = iofFixo + iofDiario;
  return Number(iofTotal.toFixed(2));
}
